/* Regista mobile interaction safety layer - QA hotfix.
   Runs only below 1000px and only provides close fallbacks. It does not hijack checkout,
   product links, quick buy submissions or other native Prestige controls. */
(function () {
  "use strict";
  var mq = window.matchMedia('(max-width: 999px)');

  function closest(event, selector) {
    if (!event || !event.target) return null;
    if (event.target.closest) {
      var direct = event.target.closest(selector);
      if (direct) return direct;
    }
    if (typeof event.composedPath === 'function') {
      var path = event.composedPath();
      for (var i = 0; i < path.length; i += 1) {
        var item = path[i];
        if (item && item.matches && item.matches(selector)) return item;
      }
    }
    return null;
  }

  function closeDialog(dialog) {
    if (!dialog) return false;
    try { if (typeof dialog.hide === 'function') { dialog.hide(); return true; } } catch (e) {}
    try { if (typeof dialog.close === 'function') { dialog.close(); return true; } } catch (e) {}
    try {
      dialog.removeAttribute('open');
      dialog.classList.remove('is-open');
      dialog.setAttribute('aria-hidden','true');
      return true;
    } catch (e) { return false; }
  }

  function closeToast() {
    var toast = document.querySelector('[data-regista-cart-toast], .regista-cart-toast');
    if (!toast) return false;
    toast.classList.remove('is-visible');
    toast.setAttribute('aria-hidden','true');
    toast.style.pointerEvents='none';
    return true;
  }

  function handle(event) {
    if (!mq.matches) return;
    var toastClose = closest(event,'.regista-cart-toast__close');
    if (toastClose) { event.preventDefault(); closeToast(); return; }

    var forced = closest(event,'[data-regista-force-close], .regista-drawer-close');
    if (forced) {
      var drawer = forced.closest && forced.closest('#cart-drawer, cart-drawer, x-drawer, dialog-element');
      if (drawer) { event.preventDefault(); closeDialog(drawer); }
      return;
    }

    var quickClose = closest(event,'.quick-buy-modal__close-button, [data-regista-quick-buy-close]');
    if (quickClose) {
      var quick = quickClose.closest && quickClose.closest('quick-buy-modal');
      if (quick) { event.preventDefault(); closeDialog(quick); }
    }
  }

  document.addEventListener('click',handle,true);
  window.RegistaMobileControls={closeToast:closeToast,closeDialog:closeDialog};
})();
